import { contact } from "./contact"
import { ObjectID } from 'bson';

export type tag = {
    _id: string;
    code: string;
    description: string;
    count: number;
    backgroundcolor: string;
    color: string;
    followers?: contact[]
}
export const emptyTag = (): tag => ({
    _id: new ObjectID().toHexString(),
    code: '',
    description: '',
    count: 0,
    backgroundcolor: '',
    color: '',
});